import { DisplayLabels, Model, Pair } from "src/components/survey/ApplicationIdentity/model/utils";

export function createdOn(model: Model): Pair {
    return {
        label: DisplayLabels.CreatedOn,
        value: new Date(model.application.metaDataCreationDate).toUTCString(),
    };
}
